import React, { FC } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Box, Grid, IconButton } from "@mui/material";
import { Attachment } from "../CreateEventMarker";
import { FileListUL } from "../eventMarker.util";

export interface DragandDropFileListProp {
  attachments: Array<Attachment>;
  removeFile: Function;
}

const DragandDropFileList: FC<DragandDropFileListProp> = (props) => {
  const { attachments, removeFile = () => {} } = props;
  return (
    <FileListUL>
      {attachments.map((file, id) => {
        return (
          <li style={{ paddingLeft: "0px !important" }} key={file.name + id}>
            <Grid container spacing={0}>
              <Grid id="fileLable" item xs={6}>
                  <label>{file.name}</label>
              </Grid>
              <Grid
                id="fileLabelSize"
                className="fileLabelPlainText"
                item
                xs={2}
              >
                <Box display={"flex"} justifyContent="right" pt={1}>
                  <span>{file.size}</span>
                </Box>
              </Grid>
              <Grid
                id="fileLabelDate"
                className="fileLabelPlainText"
                item
                xs={3}
              >
                <Box display={"flex"} justifyContent="right" pt={1}>
                  <span>{file.lastModifiedDate}</span>
                </Box>
              </Grid>
              <Grid id="fileButton" item xs={1}>
              <Box display={"flex"} justifyContent="right" >
                <IconButton
                  onClick={() => {
                    removeFile(id);
                  }}
                >
                  <CloseIcon />
                </IconButton>
                </Box>
              </Grid>
            </Grid>
          </li>
        );
      })}
    </FileListUL>
  );
};

export default DragandDropFileList;
